module.exports = __webpack_public_path__ + "static/media/flowers-2.1be63618.png";